import React from 'react';
import styled from 'styled-components';
import headerImage from '../media/images/nice_view.jpeg';
import {MoreInfoButton, ContactUsButton} from "../elements/Button";

const Wrapper = styled.div`
    position: relative;
    background-size: 120%;
    z-index: 0;
    width: 100%;
    overflow: hidden;
    background-image: url(${headerImage});
    @media (max-width: 1300px) {

    }
`;

const Mask = styled.div`
    background-image: linear-gradient(to right, rgba(61, 108, 77,0.8), rgba(61, 108, 77,0.2), rgba(0,0,0,0.1));
    z-index: 1000;
    display: block;
    width: 100%;
    height: 500px;
    overflow: hidden;
    @media (max-width: 800px) {
        height: 350px;
    }
    @media (max-width: 500px) {
        height: 200px;
    }
`;

const Header = styled.div`
    color: #ffffea;
    margin-left: 15%;
    margin-top: 230px;
    width: 750px;
    @media (max-width: 800px) {
        margin-top: 140px;
        width: 500px;
    }
    @media (max-width: 500px) {
        margin-top: 120px;
        width: 300px;
    }
`;

const Info= styled.p`
    font-family: "Roboto","serif";
    font-size: 50px;
    font-weight: bold;
    margin-bottom: 25px;
    @media (max-width: 800px) {
        font-size: 30px;
    }
    @media (max-width: 500px) {
        font-size: 18px;
    }
`;

function HeaderVideo() {
        return (
            <Wrapper>
                <Mask>
                    <Header>
                        <Info>
                             Търговия на едро с EPDM мембрани за хидроизолация
                        </Info>
                        {/*<ContactUsButton label={"Станете Наш Партньор"} />*/}
                    </Header>
                </Mask>
            </Wrapper>
        )
}

export default HeaderVideo;